import { BannerSection, SwiperPaginationContainer } from './styles'
import { SwiperProps } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

const ArrowPrev = '/images/svg/arrow-prev-slide.svg'
const ArrowNext = '/images/svg/arrow-next-slide.svg'
const ArrowLeft = '/images/svg/arrow-left.svg'
const ArrowRight = '/images/svg/arrow-right.svg'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/swiper-bundle.css'
import { BannerDefault } from 'src/services/marketplace-api/banner'
import Image from 'next/image'
import { BannerHotsite } from '../hotsiteContent/components/HotsiteCarousel'

export type CarrosselPrincipalProps = {
  swiperColor?: string
  isHotsite?: boolean
  darkTheme?: boolean
  isCategory?: boolean
  children?: React.ReactNode
}

export type BannerComponent = {
  link: string
  urlImage: string
  banner: BannerHotsite | BannerDefault
}

export const paramsSliderCarrousel: SwiperProps = {
  modules: [Navigation, Pagination, Autoplay],
  centeredSlides: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  navigation: {
    nextEl: '#btn-next-banner',
    prevEl: '#btn-prev-banner',
  },
  speed: 800,
  pagination: {
    el: '.ctrl-slide .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
}

export default function CarrosselPrincipal({
  swiperColor,
  isHotsite,
  darkTheme = false,
  isCategory = false,
  children,
}: CarrosselPrincipalProps) {
  return (
    <BannerSection
      isHotsite={isHotsite}
      swiperColor={swiperColor}
      darkTheme={darkTheme && !isCategory}
      isCategory={isCategory}
    >
      {!isHotsite && (
        <>
          <Image
            src={isCategory ? ArrowLeft : ArrowPrev}
            className="btn"
            id="btn-prev-banner"
            alt="Prev Icon"
            width={48}
            height={48}
          />
          <Image
            src={isCategory ? ArrowRight : ArrowNext}
            className="btn"
            id="btn-next-banner"
            alt="Next Icon"
            width={48}
            height={48}
          />
        </>
      )}
      {children}
      <div className="ctrl-slide">
        <SwiperPaginationContainer isHotsite={isHotsite}>
          <div className="swiper-pagination"></div>
        </SwiperPaginationContainer>
      </div>
    </BannerSection>
  )
}
